var render, staticRenderFns
import script from "./LoginSubmit.vue?vue&type=script&lang=js&"
export * from "./LoginSubmit.vue?vue&type=script&lang=js&"
import style0 from "./LoginSubmit.vue?vue&type=style&index=0&id=36329bfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36329bfc",
  null
  
)

export default component.exports